module.exports = __webpack_public_path__ + "img/logo.d426857c.png";